'use strict';
import forEach from 'lodash/forEach';
import isError from 'lodash/isError';
import noop from 'lodash/noop';
import {runInjector} from '../_libs/angular-utils';
import messages_en from '../../i18n/messages_en.properties';
import {clearOnNone} from './router/cleanup';
import {AppBootstrapper} from './AppBootstrapper';
import {configAngularDomain} from './configAngularDomain';
import {configRedux, ReduxBootstrapper} from './configRedux';
import {EpicMiddlewareInjector} from './epics';
import {
  APP_ENV,
  ENVIRONMENT,
  ENVIRONMENTS,
  FBURL,
  isCordovaBuild,
  ROOT_API_COLLECTION,
  ROOT_API_SPEC,
} from './constants';
import {globalLogger} from './logger';
import {serverStream} from './logger/ServerStream';

const angular = require('angular');

// All angular constants are officially legacy access only.
// New code and modifications should import this data using es6 module imports
export const configModule = angular
  .module('app.config', [])

  /* Environment */
  .constant('APP_ENV', APP_ENV)

  .constant('ENVIRONMENTS', ENVIRONMENTS)
  .constant('ENVIRONMENT', ENVIRONMENT)
  .constant('FBURL', FBURL) /* Required by AngularFire-Util currently */

  /* Decorate $rootScope so all scopes have access to operation environment */
  .config(['$provide', function ($provide) {
    $provide.decorator('$rootScope', ['$delegate', 'ENVIRONMENT', 'ENVIRONMENTS',
      function ($delegate, ENVIRONMENT, ENVIRONMENTS) {
        Object.defineProperties($delegate.constructor.prototype, {
          ENVIRONMENT: {value: ENVIRONMENT},
          ENVIRONMENTS: {value: ENVIRONMENTS},
        });

        return $delegate;
      }]);
    $provide.decorator('$exceptionHandler', ['$delegate', $delegate => (err, cause) => {
      globalLogger.error({err, cause});
    }]);
    $provide.decorator('$log', ['$delegate', function ($delegate) {
      globalLogger.info('Decorating $log service');
      const logLevels = {
        'log': 'info',
        'info': 'info',
        'warn': 'warn',
        'debug': 'debug',
      };

      forEach(logLevels, (bunyanLevel, angularLevel) => {
        $delegate[angularLevel] = function () {
          const args = [].slice.call(arguments);
          globalLogger[bunyanLevel](args[0]);
        };
      });

      $delegate.error = function () {
        const args = [].slice.call(arguments);
        if (args.length === 1) {
          globalLogger.error(isError(args[0]) ? {err: args[0]} : args[0]);
        } else if (args.length === 2) {
          if (isError(args[1])) {
            globalLogger.error({err: args[1]}, args[0]);
          } else {
            globalLogger.error(args[0]);
          }
        }
      };

      return $delegate;
    }]);
  }])
  .config(['$compileProvider', 'ENVIRONMENT', 'ENVIRONMENTS',
    function ($compileProvider, ENVIRONMENT, ENVIRONMENTS) {
      $compileProvider.debugInfoEnabled(ENVIRONMENT === ENVIRONMENTS.DEVELOP);
    }])

  /* Ionic */
  .config(['$ionicConfigProvider', function ($ionicConfigProvider) {
    $ionicConfigProvider.tabs.position('bottom');
    $ionicConfigProvider.views.maxCache(isCordovaBuild() ? 2 : 5);
    $ionicConfigProvider.navBar.alignTitle('center');
    $ionicConfigProvider.tabs.style('standard');
    $ionicConfigProvider.scrolling.jsScrolling(false);
    $ionicConfigProvider.views.clearOnNone = clearOnNone;
  }])

  /* Firebase */
  .config(['FirebaseUtilProvider',
    function (FirebaseUtilProvider) {
      FirebaseUtilProvider.firebaseURL(FBURL);
    }])
  /* .config(['FirebaseUtilProvider', 'ApplicationLoggerProvider', 'ExceptionLoggerProvider', 'FBURL',
    function (FirebaseUtilProvider, ApplicationLoggerProvider, ExceptionLoggerProvider, FBURL) {

      FirebaseUtilProvider.firebaseURL(FBURL);
      ApplicationLoggerProvider.firebaseURL(FBURL);
      ExceptionLoggerProvider.firebaseURL(FBURL);
    }])*/

  /* Translation */
  .config(['$translateProvider',
    function ($translateProvider) {
      $translateProvider.translations('en', messages_en);
      $translateProvider.useStaticFilesLoader({
        prefix: 'i18n/messages_',
        suffix: '.json',
      });

      $translateProvider.useMessageFormatInterpolation();
      $translateProvider.preferredLanguage('en');
      $translateProvider.fallbackLanguage('en');
      $translateProvider.useSanitizeValueStrategy('escaped');
      $translateProvider.useMissingTranslationHandler('bindOnceSupportHandler');
      $translateProvider.forceAsyncReload(true);
    }])
  .factory('bindOnceSupportHandler', function () {
    // undefined to support angular's bind once mode
    return noop;
  })

  /* Domain */
  .constant('ROOT_API_COLLECTION', ROOT_API_COLLECTION)
  .constant('ROOT_API_SPEC', ROOT_API_SPEC)
  .config(configAngularDomain)

  /* Redux */
  .config(configRedux)
  .run(EpicMiddlewareInjector)
  .factory('ReduxBootstrapper', ReduxBootstrapper)

  /* App */
  .factory('AppBootstrapper', AppBootstrapper)

  .run(runInjector(serverStream))
;



// WEBPACK FOOTER //
// ./src/js/config/index.js